const SET_CLOSURES = (state, payload) => {
  state.closures = payload;
}

const SET_PAGINATION = (state, payload) => {
  state.pagination = payload;
}

export default {
  SET_CLOSURES,
  SET_PAGINATION
}